import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/logo.png";
import ThemeToggle from "./ThemeToggle";

function decodeToken(token: string) {
    try {
        const payload = token.split(".")[1];
        return JSON.parse(atob(payload));
    } catch (error) {
        console.error("Failed to decode token:", error);
        return null;
    }
}

export default function MobileNav() {
    const [isOpen, setIsOpen] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const token = localStorage.getItem("token");

    const navigation = [
        { name: "Dashboard", href: "/dashboard" },
        { name: "Account", href: "/account" },
    ];

    if (token) {
        const userData = decodeToken(token);
        if (userData && userData.role === "admin") {
            navigation.push({ name: "Admin", href: "/admin" });
        }
    }

    const handleSignOut = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("userEmail");
        navigate("/");
    };

    return (
        <div className="lg:hidden">
            {/* Mobile menu button */}
            <div className="fixed top-0 left-0 right-0 z-40 bg-white dark:bg-gray-900 border-b border-gray-200 dark:border-gray-700 px-4 py-2">
                <div className="flex items-center justify-between">
                    <Link to="/" className="flex items-center gap-2">
                        <img src={logo} alt="Logo" className="h-8 w-auto" />
                        <div className="flex flex-col justify-center">
                            <span className="font-outfit font-bold text-lg leading-none text-indigo-900 dark:text-white">
                                Swiftclear
                            </span>
                            <span className="font-arial font-light text-xs leading-none text-indigo-700 dark:text-gray-300">
                                technologies
                            </span>
                        </div>
                    </Link>

                    <button
                        onClick={() => setIsOpen(!isOpen)}
                        className="p-2 rounded-md text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800"
                    >
                        <span className="sr-only">Open menu</span>
                        {isOpen ? (
                            <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        ) : (
                            <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                            </svg>
                        )}
                    </button>
                </div>
            </div>

            {/* Mobile menu panel */}
            {isOpen && (
                <div className="fixed inset-0 z-30 bg-gray-600 bg-opacity-75" onClick={() => setIsOpen(false)}></div>
            )}

            <div
                className={`fixed inset-y-0 left-0 z-30 w-64 bg-white dark:bg-gray-900 shadow-xl transform transition-transform duration-300 ease-in-out ${isOpen ? 'translate-x-0' : '-translate-x-full'
                    }`}
            >
                <div className="flex flex-col h-full pt-16">
                    <div className="flex-grow overflow-y-auto">
                        <nav className="px-4 pt-4 space-y-1">
                            {navigation.map((item) => (
                                <Link
                                    key={item.name}
                                    to={item.href}
                                    className={`group flex items-center px-4 py-2 text-sm font-medium rounded-md transition-colors duration-150 ${location.pathname === item.href
                                            ? "bg-indigo-50 text-indigo-900 dark:bg-gray-800 dark:text-white"
                                            : "text-gray-700 dark:text-gray-300 hover:bg-indigo-50 hover:text-indigo-900 dark:hover:bg-gray-800 dark:hover:text-white"
                                        }`}
                                    onClick={() => setIsOpen(false)}
                                >
                                    {item.name}
                                </Link>
                            ))}
                        </nav>
                    </div>

                    <div className="p-4 border-t border-gray-200 dark:border-gray-700">
                        <div className="mb-4 flex justify-start pl-4">
                            <ThemeToggle />
                        </div>
                        <Link
                            to="/contact-us"
                            className="group flex items-center px-4 py-2 text-sm font-medium rounded-md transition-colors duration-150 text-gray-700 dark:text-gray-300 hover:bg-indigo-50 hover:text-indigo-900 dark:hover:bg-gray-800 dark:hover:text-white"
                            onClick={() => setIsOpen(false)}
                        >
                            Contact
                        </Link>
                        <button
                            onClick={() => {
                                handleSignOut();
                                setIsOpen(false);
                            }}
                            className="group flex items-center px-4 py-2 text-sm font-medium rounded-md w-full text-left transition-colors duration-150 text-gray-700 dark:text-gray-300 hover:bg-indigo-50 hover:text-indigo-900 dark:hover:bg-gray-800 dark:hover:text-white"
                        >
                            Sign out
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
